module.exports = __webpack_public_path__ + "static/img/Josh-Smillie.1748c07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Josh-Smillie.jpg
// module id = D2BA
// module chunks = 0